// extracted by mini-css-extract-plugin
export var backdropBlur = "_kp-0";
export var contentCard = "_kp-5";
export var frame = "_kp-2";
export var image = "_kp-4";
export var imagePane = "_kp-3";
export var modal = "_kp-1";